import { z } from 'zod/v4';

/**
 * The logo widget's structured **styles** group — the data carried by the
 * envelope's `styles` field, following image/line/indent rather than the open
 * JSS `styleBagSchema` record.
 *
 * `maxWidth` (px) is the only one that renders: it caps the logo box, and the
 * control seeds it from the picked file's natural width. `borderRadius` is
 * persisted by the host model's defaults but no stylesheet has ever read it —
 * modelled `nullish` so it round-trips without becoming required.
 */
export const logoStylesSchemaLegacy = z.object({
    maxWidth: z.number(),
    borderRadius: z.number().nullish(),
});

export type LogoStylesLegacy = z.infer<typeof logoStylesSchemaLegacy>;

/** Default logo styles bag — mirrors the `logoStyles` literal in the host's `logo.model.ts`. */
export const createLogoStylesLegacy = (overrides: Partial<LogoStylesLegacy> = {}): LogoStylesLegacy => ({
    maxWidth: 100,
    borderRadius: 0,
    ...overrides,
});
